import { Box, Collapse, IconButton, Typography } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useState } from 'react';
import { useSelectedProviderStyles } from '../styles';

export type CollapseItemProps = {
  title: string;
  content: React.ReactNode;
};

export const CollapseItem: React.VFC<CollapseItemProps> = props => {
  const { classes } = useSelectedProviderStyles();
  const [ open, setOpen ] = useState(false);

  return (
    <Box>
      <Box onClick={() => setOpen(p => !p)} className={classes.collapseItemButton}>
        <Box display="flex" alignItems="center" gap="0.25rem" py={1}>
          <IconButton size="small">
            {open ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
          </IconButton>
          <Typography>{props.title}</Typography>
        </Box>
      </Box>
      <Collapse in={open}>
        <Box pl="30px" pt={0.5} pb={2}>
          {props.content}
        </Box>
      </Collapse>
    </Box>
  );
};
